export default {
  removeMeetingWarning:
    'The scheduling feature is discontinued. Please use the {app} to schedule your video meetings.',
  scheduleMeetingTips:
    'Please note that we removed meetings from this app. To use meetings, we recommend the {app}.',
  migrateToPluginAlert:
    'Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}',
} as const;
